/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import LegalPageLayout from './LegalPageLayout';

const PrivacyPolicyFR = () => (
  <LegalPageLayout
    title="Politique de confidentialité"
    subtitle="Comment Body-Up traite vos données personnelles dans le respect de la nLPD (Suisse) et du RGPD (Union européenne)."
    lastUpdated="Dernière mise à jour : 21 juin 2026"
    seoTitle="Politique de confidentialité | Body-Up Personal Training Nyon"
    seoPath="/politique-confidentialite"
  >
    <h2>1. Responsable du traitement</h2>
    <p>
      Le responsable du traitement des données personnelles collectées via ce site est :
    </p>
    <ul>
      <li><strong>Raison sociale</strong> : Body-Up, Laurent Wälti</li>
      <li><strong>Forme juridique</strong> : Raison individuelle</li>
      <li><strong>Titulaire</strong> : Laurent Wälti</li>
      <li><strong>IDE / UID</strong> : CHE-201.319.764</li>
      <li><strong>N° au registre du commerce</strong> : CH-550.1.081.439-0 (Vaud)</li>
      <li><strong>Adresse</strong> : Route des Tattes-d'Oie 95, 1260 Nyon, Suisse</li>
      <li><strong>Contact</strong> : <a href="mailto:info@body-up.ch">info@body-up.ch</a></li>
    </ul>
    <p className="text-xs text-gray-500">
      Body-Up n'a pas désigné de délégué à la protection des données (DPO). Pour toute question relative aux données personnelles, écrivez à <a href="mailto:info@body-up.ch">info@body-up.ch</a>.
    </p>

    <h2>2. Données que nous collectons</h2>

    <h3>2.1 Site public</h3>
    <ul>
      <li><strong>Informations techniques</strong> : adresse IP, type de navigateur, pages visitées (uniquement si vous y avez consenti via la bannière cookies).</li>
      <li><strong>Formulaire de contact</strong> : nom, e-mail, message que vous nous adressez librement.</li>
    </ul>

    <h3>2.2 Calculateur de calories</h3>
    <ul>
      <li><strong>Données corporelles et nutritionnelles</strong> : sexe, âge, poids, taille, morphotype, objectif (perte de poids, prise de muscle, maintien), niveau d'activité, type d'entraînement, rythme alimentaire.</li>
      <li><strong>E-mail</strong> : nécessaire pour vous renvoyer vos résultats et associer vos calculs à un éventuel compte client.</li>
    </ul>
    <p>
      Ces données restent strictement entre vous et Body-Up. Elles ne sont <strong>jamais</strong> transmises à des outils d'analyse (Google Analytics) ou de publicité (Meta Pixel), même si vous avez accepté ces outils.
    </p>

    <h3>2.3 Espace client</h3>
    <ul>
      <li><strong>Compte</strong> : nom, e-mail, mot de passe (haché, jamais stocké en clair).</li>
      <li><strong>Suivi quotidien</strong> : aliments enregistrés, mesures, photos éventuelles, journal de progression.</li>
      <li><strong>Plans nutritionnels générés</strong> : contenu personnalisé, recettes, macros.</li>
      <li><strong>Messagerie coaching</strong> (offres incluant le coaching) : contenu de vos échanges avec votre coach.</li>
    </ul>

    <h2>3. Finalités du traitement</h2>
    <ul>
      <li>Vous fournir le service demandé (calcul, plan, suivi, coaching).</li>
      <li>Vous envoyer vos résultats et communications liées à votre compte.</li>
      <li>Améliorer le site (uniquement si vous y avez consenti via les cookies analytiques).</li>
      <li>Vous proposer nos offres (uniquement si vous y avez consenti via les cookies marketing).</li>
      <li>Respecter nos obligations légales (facturation, comptabilité).</li>
    </ul>

    <h2>4. Base légale</h2>
    <ul>
      <li><strong>Exécution du contrat</strong> : pour les services achetés ou créés via votre compte.</li>
      <li><strong>Consentement</strong> : pour les cookies non nécessaires, les newsletters et le marketing.</li>
      <li><strong>Intérêt légitime</strong> : sécurité du site, prévention de la fraude.</li>
      <li><strong>Obligation légale</strong> : conservation des factures.</li>
    </ul>

    <h2>5. Durée de conservation</h2>
    <ul>
      <li>Compte client et calculs : tant que votre compte existe, puis suppression ou anonymisation dans les 12 mois après votre demande.</li>
      <li>Données de facturation : 10 ans (obligation comptable suisse).</li>
      <li>Cookies analytiques et marketing : conservés au maximum 13 mois après votre dernière visite.</li>
      <li>Choix de consentement : 12 mois, ou jusqu'à modification de la politique.</li>
    </ul>

    <h2>6. Fournisseurs et destinataires</h2>
    <p>
      Body-Up s'appuie sur les fournisseurs suivants pour faire fonctionner le site. <strong>Aucune donnée nutritionnelle, corporelle ou de plan n'est transmise à des outils tiers.</strong>
    </p>
    <ul>
      <li><strong>MongoDB Atlas / Hébergement</strong> : stockage chiffré des comptes et données client (Suisse / UE).</li>
      <li><strong>Stripe</strong> : traitement sécurisé des paiements (Irlande / États-Unis avec garanties contractuelles).</li>
      <li><strong>SMTP <code>info@body-up.ch</code></strong> : envoi des e-mails transactionnels (Suisse).</li>
      <li><strong>Google Fonts</strong> : chargement des polices (chargées depuis les CDN Google).</li>
      <li><strong>Système de réservation Pure Informatique</strong> : prise de rendez-vous (Suisse).</li>
      <li><strong>Google Analytics / Meta Pixel</strong> : <em>non actifs actuellement</em>. Seront activés ultérieurement et uniquement après votre consentement.</li>
    </ul>

    <h2>7. Transferts hors Suisse / UE</h2>
    <p>
      Certains fournisseurs (Stripe, Google Fonts) traitent les données aux États-Unis. Ces transferts s'appuient sur les clauses contractuelles types de la Commission européenne et, lorsque applicable, sur la décision d'adéquation Suisse–États-Unis (Data Privacy Framework).
    </p>

    <h2>8. Vos droits</h2>
    <p>Selon la nLPD et le RGPD, vous disposez des droits suivants :</p>
    <ul>
      <li><strong>Accès</strong> à vos données.</li>
      <li><strong>Rectification</strong> en cas d'erreur.</li>
      <li><strong>Suppression</strong> de votre compte et de vos données.</li>
      <li><strong>Opposition</strong> à un traitement, notamment marketing.</li>
      <li><strong>Portabilité</strong> de vos données dans un format lisible.</li>
      <li><strong>Retrait du consentement</strong> à tout moment, sans affecter la licéité des traitements passés.</li>
    </ul>
    <p>
      Pour exercer ces droits : <a href="mailto:info@body-up.ch">info@body-up.ch</a>. Une preuve d'identité pourra vous être demandée. Réponse dans un délai de 30 jours.
    </p>

    <h2>9. Données sensibles : nos engagements</h2>
    <p>Les données nutritionnelles, corporelles ou liées à la santé que vous saisissez (poids, taille, objectifs, allergies, plans alimentaires, messagerie coaching) sont considérées comme particulièrement sensibles. À ce titre :</p>
    <ul>
      <li>Elles ne sont jamais transmises à Google Analytics, Meta Pixel ou à un quelconque outil publicitaire.</li>
      <li>Elles ne sortent pas du périmètre Body-Up et de ses sous-traitants techniques nécessaires (hébergement, e-mail).</li>
      <li>Elles ne sont jamais revendues, échangées ou partagées à des fins commerciales.</li>
    </ul>
    <p className="text-xs text-zinc-500 italic">
      Les recommandations nutritionnelles fournies via le calculateur ou les plans ne constituent pas un avis médical. En cas de doute, consultez un professionnel de santé.
    </p>

    <h2>10. Sécurité</h2>
    <p>
      Les mots de passe sont hachés (bcrypt). Les communications utilisent HTTPS. L'accès administrateur est protégé par authentification multi-facteurs lorsque possible et est journalisé.
    </p>

    <h2>11. Réclamation</h2>
    <p>
      Vous pouvez adresser une réclamation au Préposé fédéral à la protection des données et à la transparence (PFPDT, Suisse) ou à l'autorité de protection des données compétente dans votre pays de résidence (UE).
    </p>

    <h2>12. Modifications de la politique</h2>
    <p>
      Cette politique peut évoluer. En cas de changement important (nouveau fournisseur, nouvelle finalité, nouveaux cookies), une demande de consentement vous sera à nouveau présentée.
    </p>
  </LegalPageLayout>
);

export default PrivacyPolicyFR;
